export default __webpack_public_path__ + "static/media/CC10-QUICK.13aba7bf.png";